import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-string-checkbox',
  template: `
    <mat-checkbox
      [checked]="isChecked"
      (change)="onCheckboxChange($event.checked)"
      (blur)="onTouched()"
      [disabled]="disabled">
      <ng-content></ng-content>
    </mat-checkbox>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StringCheckboxComponent),
      multi: true
    }
  ]
})
export class StringCheckboxComponent implements ControlValueAccessor {
  @Input() trueValue!: string;
  @Input() falseValue!: string;

  isChecked = false;

  // eslint-disable-next-line no-empty-function,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  onChange = (_: string) => {};
  // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
  onTouched = () => {};

  touched = false;

  disabled = false;

  writeValue(value): void {
    this.isChecked = value === this.trueValue;
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onCheckboxChange(checked: boolean): void {
    const newValue = checked ? this.trueValue : this.falseValue;
    this.onChange(newValue);
    this.isChecked = checked;
  }
}
